// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33e40dc5","455":"ea8da8c6","977":"0887011b"}[chunkId] + ".chunk.js";
};